import { unwrapList } from '@shared/lib'
import type { Payment } from './types'

export interface PaymentHistoryPage {
  results: Payment[]
  count: number
}

/** Ответ `history/` как он приходит: пустое тело, массив или конверт. */
export type PaymentHistoryResponse =
  | Payment[]
  | { results?: Payment[]; count?: number }
  | null
  | undefined

/**
 * Приводит ответ истории к странице. Бэк отвечает тремя способами: 204 без тела
 * (история пуста, `data` — `undefined`), обычным массивом и конвертом
 * `{count, results}`, когда в окружении включена пагинация.
 */
export function parsePaymentHistory(data: PaymentHistoryResponse): PaymentHistoryPage {
  const results = unwrapList(data)
  const count = data && !Array.isArray(data) ? data.count : undefined
  return { results, count: count ?? results.length }
}
